import firestore from './firestoreService'

const COLL = 'verses'

export const versesService = {
  subscribeVerses: (cb, onError) =>
    firestore.subscribe(COLL, { orderBy: [['reference']] }, cb, onError),

  getVersesOnce: () => firestore.getAll(COLL),

  addVerse: (data) =>
    firestore.add(COLL, { ...data, addedAt: firestore.timestamp() }),

  updateVerse: (id, data) =>
    firestore.update(COLL, id, data),

  deleteVerses: (ids) =>
    firestore.batch(b => ids.forEach(id => b.delete(COLL, id))),

  existsByReference: (reference) =>
    firestore.exists(COLL, 'reference', reference),

  existsByText: (text) =>
    firestore.exists(COLL, 'text', text),

  seedVerses: (verses) =>
    firestore.batch(b =>
      verses.forEach(v => b.add(COLL, { ...v, addedAt: firestore.timestamp() }))),
}

export default versesService
